var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { commonAttrs } from '../../utils';
import { CFContainerElements } from './Container.styles';
export const CFContainer = (_a) => {
    var { align = 'left', background, backgroundImage, backgroundImageSize = 'cover', withBackgroundBlur, border, borderRadius, children, dir = 'vertical', flex, gap = 'd', height, pad, shadow, spacingMode = 'packed', width = 'fill' } = _a, rest = __rest(_a, ["align", "background", "backgroundImage", "backgroundImageSize", "withBackgroundBlur", "border", "borderRadius", "children", "dir", "flex", "gap", "height", "pad", "shadow", "spacingMode", "width"]);
    const { Root } = CFContainerElements;
    return (React.createElement(Root, Object.assign({ bufferedProps: {
            align,
            background,
            backgroundImage,
            backgroundImageSize,
            border,
            borderRadius,
            dir,
            flex,
            gap,
            height,
            pad,
            shadow,
            spacingMode,
            width,
            withBackgroundBlur,
        } }, commonAttrs(rest)), children));
};
